<template>

<div class="form-group mb-0">
    <div class="input-group">
        <div class="input-group-prepend">
            <div class="input-group-text">
                <span class="icon icon-envelope"></span>
            </div>
        </div> 

        <select v-if='isReady' id="projectNotifs" class="custom-select" @change='changeState' v-model='state'>
            <optgroup label="Известия за нови съобщения">
                <option value=0>НЕ</option>
                <option value=1>ДА</option>
            </optgroup>
        </select>
    </div>
</div>

</template>

<script>
    export default {

        mounted() {
            this.getData();
        },

        props : ['pid'],

        created() {
           
        },

        data() {
            return {
                disabled : [],
                isReady  : false,
                state    : 1
            }
        },

        methods : {

            getData() {
                this.ajax.call('usr:gdn', {}, (r) => {
                    if( r.status == 'success' ) {

                        this.disabled = r.data;
                        
                        if( this.disabled.includes( this.pid ) ) {
                            this.state = 0;
                        } else {
                            this.state = 1;
                        }

                        this.isReady = true;


                    }
                })
            },

            changeState() {
                this.ajax.call('usr:chns', { p : this.pid, s : this.state }, (r) => {
                    if( r.status == 'success' ) {
                        $.notify("Нотификациите бяха променени","success");
                    }
                })
            }

        }

    }
</script>
